import { render, staticRenderFns } from "./Ysyterms.vue?vue&type=template&id=330a59e0&scoped=true&"
import script from "./Ysyterms.vue?vue&type=script&lang=js&"
export * from "./Ysyterms.vue?vue&type=script&lang=js&"
import style0 from "./Ysyterms.vue?vue&type=style&index=0&id=330a59e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a59e0",
  null
  
)

export default component.exports